import { render, staticRenderFns } from "./ListSkeleton.vue?vue&type=template&id=a78736e2&scoped=true&"
import script from "./ListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ListSkeleton.vue?vue&type=style&index=0&id=a78736e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78736e2",
  null
  
)

export default component.exports